import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions, useLoaders } from '@/shared';
import { useGetRouter } from '@/store/erp/router';
import { SaveRouter } from './../../shared/components';

export type UpdateRouterPageProps = {};

const UpdateRouterPage: React.FC<UpdateRouterPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_router);
  const returnUrlRoutesrPage = '/configuracion-red/routers';

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetRouter(id!);

  useLoaders(isLoading);
  if (isLoading || isRefetching) return null;
  if (!data?.data?.id_router) return <Navigate to={returnUrlRoutesrPage} />;

  return <SaveRouter title="Editar Router" router={data.data} />;
};

export default UpdateRouterPage;
